<template lang="pug">

tr

    //- Firma
    td
        router-link(:to='{ name: "addresses/update", params: { id: addressModel.id }}') {{ addressModel.firm || addressModel.name }}

    td(v-html="types")

    //- Unternehmen
    td
        template(v-for='(companyModel, index) in companyModels')
            span(v-if='index > 0') , 
            router-link(v-bind:to='{ name: "companies/update", params: { id: companyModel.id }}') {{ companyModel.name }}

    //- Stadt
    td {{ addressModel.city }}

    //- Bundesland
    td {{ stateName }}

    //- Land
    td {{ countryModel.name }}


</template>

<script>

    //noinspection JSUnusedGlobalSymbols
    import * as R from "ramda";

    export default {

        computed: {

            stateName() {
                return R.propOr('-', 'name', this.stateModel)
            },

            types() {
                const types = []

                if (this.addressModel.isShippingAddress) {
                    let label = 'Lieferadresse'
                    if (this.addressModel.isDefaultShippingAddress) {
                        label += '*'
                    }
                    types.push(label)
                }

                if (this.addressModel.isCorrespondenceAddress) {
                    let label = 'Korrespondenzadresse'
                    if (this.addressModel.isDefaultCorrespondenceAddress) {
                        label += '*'
                    }
                    types.push(label)
                }

                if (this.addressModel.isBillingAddress) {
                    let label = 'Rechnungsadresse'
                    if (this.addressModel.isDefaultBillingAddress) {
                        label += '*'
                    }
                    types.push(label)
                }

                return types.join('<br />')
            },

        },

        props: {

            addressModel: {
                type: Object,
                required: true
            },

            companyModels: {
                type: Array,
                default: R.always([])
            },

            countryModel: {
                type: Object,
                required: true
            },

            stateModel: {
                type: Object,
                default: R.always({})
            },

        }

    }

</script>
